import { writable } from 'svelte/store';

const STORAGE_KEY = 'workspaceMode';

function readStoredMode(): string {
	if (typeof localStorage === 'undefined') return 'design';
	return localStorage.getItem(STORAGE_KEY) || 'design';
}

export const workspaceMode = writable(readStoredMode());

export function setWorkspaceMode(mode: string) {
	workspaceMode.set(mode);
	if (typeof localStorage !== 'undefined') {
		localStorage.setItem(STORAGE_KEY, mode);
	}
}
